<template>
  <div class="form-group">
    <div class="input">
      <input id="searchTerm" class="form-control" v-model="searchterm" :class="{ '-filled': searchterm }" type="text" name="searchTerm" @keydown="searchWithEnter($event)">
      <div class="input-background">
        <label class="control-label" for="search">{{ $t('list.search.searchPlaceholder') }}</label>
      </div>
      <div class="clear-icon icon-times-before" v-if="searchterm" @click="clearSearchTerm()"></div>
      <div class="search-icon icon-search-before"></div>
    </div>
    <div class="help-block"><span>{{ $t('list.search.helpBlock') }}</span></div>
  </div>
  <div class="btn -btn-alpha" @click="search()">
    <span>{{ $t('list.search.searchPlaceholder') }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useFilterStore } from '@/stores/filter'
import { useGlobalStore } from '@/stores'

const filters = useFilterStore()
const globals = useGlobalStore()
const searchterm = computed({
  get () {
    return filters.searchTerm
  },
  set (value) {
    filters.searchTerm = value
  }
})

function search() {
  if (window.dataLayer && filters.searchTerm) {
    window.dataLayer.push({
      'searchterm': filters.searchTerm,
      'event': 'searchterm-event'
    })
  }
  globals.filter()
}

function searchWithEnter (event)
{
  if (event.keyCode == 13)
  {
    search()
  }
}

function clearSearchTerm () {
  filters.searchTerm = ''
  globals.filter()
}
</script>

